export const Apis = {
    loginApi: `${process.env.REACT_APP_BASE_URL}/api/auth/login`,
    forgetPassword: `${process.env.REACT_APP_BASE_URL}/api/auth/forgetPassword`,
    resetPassword: `${process.env.REACT_APP_BASE_URL}/api/auth/resetPassword`,
    resetPasswordForDoctor: `${process.env.REACT_APP_BASE_URL}/api/auth/resetPasswordForDoctor`,
    deleteUserApi: `${process.env.REACT_APP_BASE_URL}/api/doctor/deleteDoctor`,
    deleteLocation: `${process.env.REACT_APP_BASE_URL}/api/location/deleteLocation`,
    addDoctor: `${process.env.REACT_APP_BASE_URL}/api/doctor/addDoctor`,
    addRole: `${process.env.REACT_APP_BASE_URL}/api/role/addRole`,
    addLocation: `${process.env.REACT_APP_BASE_URL}/api/location/addLocation`,
    allDoctors: `${process.env.REACT_APP_BASE_URL}/api/doctor/getAllDoctors`,
    allRole: `${process.env.REACT_APP_BASE_URL}/api/role/getAllRole`,
    getSingleDoctor: `${process.env.REACT_APP_BASE_URL}/api/doctor/getDoctor`,
    getSingleRole: `${process.env.REACT_APP_BASE_URL}/api/role/getRole`,
    getSingleLocation: `${process.env.REACT_APP_BASE_URL}/api/location/Location`,
    getLocations: `${process.env.REACT_APP_BASE_URL}/api/location/Locations`,
    editRole: `${process.env.REACT_APP_BASE_URL}/api/role/editRole`,
    editDoctor: `${process.env.REACT_APP_BASE_URL}/api/doctor/editDoctor`,
    editLocation: `${process.env.REACT_APP_BASE_URL}/api/location/editLocation`,
    editStatus: `${process.env.REACT_APP_BASE_URL}/api/location/editStatus`,
    getLoginUserData: `${process.env.REACT_APP_BASE_URL}/api/auth/getAdminDetails`,
    editLoginUserDetails: `${process.env.REACT_APP_BASE_URL}/api/auth/editAdminDetails`,
    setPassword: `${process.env.REACT_APP_BASE_URL}/api/auth/setnewPasswordForAdmin`,
    getAllApprovedAppointment: `${process.env.REACT_APP_BASE_URL}/api/appointment/getAllApprovedAppointment`,
    getAllCompletedAppointment: `${process.env.REACT_APP_BASE_URL}/api/appointment/getAllCompletedAppointment`,
    addDefaultTimeForAppointment: `${process.env.REACT_APP_BASE_URL}/api/appointment/addDefaultTimeForAppointment`,
    getDefaultTimeForAppointment: `${process.env.REACT_APP_BASE_URL}/api/appointment/getDefaultTimeForAppointment`,
    addPrivacyPolicy: `${process.env.REACT_APP_BASE_URL}/api/websitepages/addPrivacyPolicy`,
    getPrivacyPolicy: `${process.env.REACT_APP_BASE_URL}/api/websitepages/getPrivacyPolicy`,
    addTermsAndConditions: `${process.env.REACT_APP_BASE_URL}/api/websitepages/addTermsAndConditions`,
    getTermsAndConditions: `${process.env.REACT_APP_BASE_URL}/api/websitepages/getTermsAndConditions`,
}
